import { createSlice } from "@reduxjs/toolkit";
import {
  getWaybills,
  getWaybillById,
  createWaybill,
} from "./thunk";

interface WaybillState {
  waybillList: any[];
  selectedWaybill: any | null;
  pagination: {
    total: number;
    page: number;
    pageSize: number;
  };
  isLoading: boolean;
  error: string | null;
}

export const initialState: WaybillState = {
  waybillList: [],
  selectedWaybill: null,
  pagination: {
    total: 0,
    page: 1,
    pageSize: 10,
  },
  isLoading: false,
  error: null,
};

const waybillsSlice = createSlice({
  name: "waybills",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Get Waybills
      .addCase(getWaybills.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getWaybills.fulfilled, (state, action: any) => {
        state.isLoading = false;
        state.waybillList = action.payload.data || [];
        state.pagination = {
          total: action.payload.meta?.total || 0,
          page: parseInt(action.payload.meta?.page || '1'),
          pageSize: parseInt(action.payload.meta?.pageSize || '10'),
        };
      })
      .addCase(getWaybills.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || null;
      })
      // Get Waybill by ID
      .addCase(getWaybillById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getWaybillById.fulfilled, (state, action: any) => {
        state.isLoading = false;
        state.selectedWaybill = action.payload;
      })
      .addCase(getWaybillById.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || null;
      })
      // Create Waybill
      .addCase(createWaybill.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createWaybill.fulfilled, (state, action: any) => {
        state.isLoading = false;
        state.waybillList.unshift(action.payload.data);
      })
      .addCase(createWaybill.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || null;
      });
  },
});

export default waybillsSlice.reducer;
